export default {
      id: "webmail-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#webmail",
      toString: function () {
        return this.url;
      }
    }